import { FC } from "react";
import { Box, Center, HStack, Text } from "@chakra-ui/react";

import { formatPriceWithoutZeros } from "../../../../../utils";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";

export const SbpTransferBanksPageAmount: FC = () => {
  const amount = useSbpTransferStore(state => state.amount);
  const formattedAmount = formatPriceWithoutZeros(Number(amount));

  return (
    <Box bg="white" borderRadius="16px" p="20px">
      <Text mt="4px" mb="14px">Сумма перевода</Text>

      <HStack mb="3px" justifyContent="space-between">
        <Text mt="-4px" variant="brand" fontFamily="Normalidad Medium Var" fontSize="22px">
          {formattedAmount}
        </Text>

        <Center w="86px" h="22px" bg="gray.50" justifyContent="center" borderRadius="35px">
          <Text fontSize="9px">Перевод по СБП</Text>
        </Center>
      </HStack>
    </Box>
  );
};
